var _rect, _g, _rect2, _rect3, _rect4, _path, _path2, _rect5, _rect6, _rect7, _g2, _rect8, _rect9, _rect10, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectCardBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 381,
    height: 227,
    viewBox: "0 0 381 227",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4047_72433",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 381,
    height: 227
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 381,
    height: 227,
    rx: 8,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4047_72433)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    clipPath: "url(#clip0_4047_72433)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 57.7071,
    y: -14.3809,
    width: 114.427,
    height: 114.427,
    rx: 8.5,
    transform: "rotate(-45 57.7071 -14.3809)",
    stroke: "#DBDBDB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 173.707,
    y: 56.8086,
    width: 35.5002,
    height: 35.5002,
    rx: 8.5,
    transform: "rotate(-45 173.707 56.8086)",
    stroke: "#EAEAEA"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.6
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -35.2078,
    y: 28,
    width: 294.982,
    height: 151.027,
    rx: 20,
    transform: "rotate(45 -35.2078 28)",
    fill: "#F4FAFF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-43 85L108 85C113.523 85 118 89.4772 118 95V190C118 195.523 113.523 200 108 200H-43L-43 85Z",
    fill: "url(#paint0_linear_4047_72433)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-42.5 85.5L108 85.5C113.247 85.5 117.5 89.7533 117.5 95V190C117.5 195.247 113.247 199.5 108 199.5H-42.5L-42.5 85.5Z",
    stroke: "#B2B9C0",
    strokeOpacity: 0.42
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 277.121,
    y: 247.33,
    width: 83.7326,
    height: 112.427,
    rx: 7.5,
    transform: "rotate(-45 277.121 247.33)",
    stroke: "#F0F5FC",
    strokeWidth: 3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 106.707,
    y: 185.809,
    width: 35.5002,
    height: 35.5002,
    rx: 8.5,
    transform: "rotate(-45 106.707 185.809)",
    stroke: "#EAEAEA"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 173.707,
    y: 56.8086,
    width: 35.5002,
    height: 35.5002,
    rx: 8.5,
    transform: "rotate(-45 173.707 56.8086)",
    stroke: "#EAEAEA"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4047_72433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.0329 133.553L87.431 136.424L87.2684 136.603L87.0267 136.587C86.8556 136.575 86.685 136.567 86.5148 136.561C86.355 136.567 86.1948 136.575 86.0342 136.587L85.7826 136.605L85.6186 136.413L83.1752 133.559L82.8772 133.634L82.7551 133.15L82.8772 133.634C82.0804 133.835 81.2926 134.096 80.5362 134.409C79.7791 134.723 79.0376 135.096 78.3318 135.517L78.3317 135.517L78.0677 135.675L78.3586 139.43L78.3781 139.68L78.1882 139.845C77.7076 140.263 77.2561 140.716 76.8391 141.197L76.6739 141.388L76.4226 141.368L72.6762 141.078L72.5187 141.342C72.0976 142.048 71.7249 142.789 71.4112 143.545C71.0979 144.303 70.8372 145.091 70.6359 145.888L70.6359 145.888L70.5607 146.186L73.4201 148.635L73.6113 148.799L73.5937 149.05C73.5715 149.366 73.5604 149.682 73.5604 149.994C73.5604 150.314 73.572 150.637 73.5952 150.961L73.6132 151.212L73.4217 151.376L70.5678 153.82L70.6431 154.118C70.8443 154.915 71.1051 155.703 71.418 156.46L90.0329 133.553ZM90.0329 133.553L90.379 133.636L90.495 133.149L90.379 133.636C91.2251 133.837 92.0616 134.099 92.8647 134.413C93.6683 134.728 94.4551 135.101 95.2039 135.523L95.204 135.523L95.4864 135.683L95.1792 139.427L95.1578 139.688L95.3602 139.855C95.8698 140.273 96.3484 140.726 96.7903 141.208L96.9539 141.386L97.1952 141.368L101.19 141.076L101.365 141.353C101.811 142.058 102.205 142.799 102.537 143.555C102.868 144.312 103.144 145.099 103.357 145.895L103.433 146.18L100.409 148.626L100.205 148.791L100.224 149.052C100.248 149.367 100.26 149.683 100.26 149.994C100.26 150.313 100.247 150.636 100.223 150.959L100.203 151.22L100.407 151.385L103.426 153.826L103.349 154.112C103.137 154.907 102.861 155.694 102.53 156.45C102.198 157.207 101.803 157.948 101.357 158.654L101.357 158.654L101.183 158.931L97.1796 158.638L96.9388 158.62L96.7752 158.798C96.3325 159.279 95.8532 159.731 95.3429 160.149L95.1398 160.315L95.1613 160.576L95.4678 164.314L95.1854 164.473L95.1854 164.473C94.4366 164.895 93.6497 165.269 92.847 165.583C92.0429 165.897 91.2065 166.159 90.3604 166.361L90.0144 166.443L87.4074 163.567L87.2451 163.388L87.0039 163.404C86.8405 163.414 86.6775 163.423 86.5148 163.428M90.0329 133.553L86.5148 163.428M86.5148 163.428C86.362 163.423 86.209 163.415 86.0556 163.404L85.8045 163.386L85.6408 163.577L83.1927 166.437L82.8947 166.362L82.7723 166.847L82.8947 166.362C82.0979 166.161 81.3102 165.9 80.5528 165.587C79.7966 165.273 79.055 164.9 78.3493 164.479L78.3492 164.479L78.0853 164.321L78.3756 160.574L78.395 160.323L78.2045 160.158C77.7234 159.741 77.2711 159.289 76.8533 158.808L76.6882 158.618L76.4373 158.638L72.6835 158.929L72.526 158.665L72.526 158.665C72.1047 157.959 71.7321 157.217 71.418 156.46L86.5148 163.428ZM87 142.083C91.181 142.552 94.4341 145.921 94.4341 149.994C94.4341 154.068 91.181 157.437 87 157.906M86 142.09C82.0781 142.583 79.0345 145.94 79.0345 149.994C79.0345 154.049 82.0781 157.406 86 157.899M86.5135 141.541C86.3435 141.532 86.1723 141.527 86 141.527V141.586C81.8011 142.082 78.5345 145.663 78.5345 149.994C78.5345 154.325 81.8011 157.906 86 158.403V158.462C86.1723 158.462 86.3435 158.457 86.5135 158.448C86.6746 158.457 86.8368 158.462 87 158.462V158.409C91.4356 157.938 94.9341 154.366 94.9341 149.994C94.9341 145.623 91.4356 142.051 87 141.58V141.527C86.8368 141.527 86.6746 141.532 86.5135 141.541ZM79.5345 149.994C79.5345 146.04 82.6243 142.793 86.5152 142.543C90.6752 142.795 93.9341 146.065 93.9341 149.994C93.9341 153.924 90.6752 157.194 86.5152 157.446C82.6243 157.196 79.5345 153.948 79.5345 149.994Z",
    stroke: "#E4E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9999 140.039L85.0085 142.03L86.9999 144.022C90.2941 144.022 92.9741 146.702 92.9741 149.996C92.9741 153.29 90.2941 155.97 86.9999 155.97L85.0085 157.962L86.9999 159.953C92.4902 159.953 96.9568 155.486 96.9568 149.996C96.9568 144.506 92.4902 140.039 86.9999 140.039V140.039Z",
    fill: "#EAF1FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.026 149.996C81.026 146.702 83.706 144.022 87.0001 144.022V140.039C81.5098 140.039 77.0432 144.506 77.0432 149.996C77.0432 155.486 81.5098 159.953 87.0001 159.953V155.97C83.706 155.97 81.026 153.29 81.026 149.996V149.996Z",
    fill: "#EAF1FB"
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: -40,
    y: 101,
    width: 109,
    height: 2,
    rx: 1,
    fill: "#DFE1E4"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: -40,
    y: 116,
    width: 109,
    height: 2,
    rx: 1,
    fill: "#DFE1E4"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: -70,
    y: 131,
    width: 109,
    height: 2,
    rx: 1,
    fill: "#DFE1E4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4047_72433",
    x1: 37,
    y1: 100,
    x2: 37.5,
    y2: 200,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4047_72433"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 381,
    height: 227,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4047_72433"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white",
    transform: "translate(70 133)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectCardBackground);
export default __webpack_public_path__ + "static/media/project-card-background.87874948b2b538a5e32f0ea8c6019c15.svg";
export { ForwardRef as ReactComponent };